export default [
	{
		modulo: 20,
		privilegio: 165,
		routerName: 'procedimento-operacional',
		routerPath: '/procedimento-operacional',
		componentName: 'ProcedimentoOperacional',
		componentPath: 'modules/layout/documentacao/procedimento-operacional/main'
	},
	{
		modulo: 20,
		privilegio: 190,
		routerName: 'normas-legislacao',
		routerPath: '/normas-legislacao',
		componentName: 'NormasLegislacao',
		componentPath: 'modules/layout/documentacao/normas-legislacao/main'
	},
	{
		modulo: 20,
		privilegio: 191,
		routerName: 'planilhas-projetos',
		routerPath: '/planilhas-projetos',
		componentName: 'PlanilhasProjetos',
		componentPath: 'modules/layout/documentacao/planilhas-projetos/main'
	},
]
